// @flow

import styled, { css } from "styled-components";
import DefaultButton from "../../_atom/Buttons/default";
import MessageBox from "../../_molecule/MessageBox";

import buildColor from "../../_static/ColorPalette";

export const WarningMessage = styled(MessageBox)`
  min-height: 40px;
  display: flex;
`;

export const Wrapper = styled.div`
  position: relative;
  background-color: ${buildColor("white", "100")};
`;

export const ConfirmationButtonContainer = styled.div`
  padding: 8px;
  ${(props) =>
    props.hasTopMargin &&
    css`
      margin-top: 8px;
    `};
  text-align: right;
  background-color: ${buildColor("blue", "000")};
  border-top: 1px solid ${buildColor("grey", "300")};
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const BetSummaryContainer = styled.div`
  padding: 0 8px;
  overflow-y: scroll;
`;

export const RetainButton = styled(DefaultButton)`
  font-size: 12px;
  background-color: ${buildColor("white", "0")};
  color: ${buildColor("blue_accent", "500")};
  margin-right: 20px;
  font-weight: bold;
`;

export const WarningMessageWrapper = styled.div`
  padding: 8px 8px 0;
`;

export const WagerAmountContainer = styled.span`
  font-size: 14px;
  font-weight: bold;
`;

export const TotalAmountText = styled.strong`
  font-size: 14px;
`;
